import { render, staticRenderFns } from "./user_consents.vue?vue&type=template&id=69447a52&scoped=true&"
import script from "./user_consents.vue?vue&type=script&lang=js&"
export * from "./user_consents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69447a52",
  null
  
)

export default component.exports